export enum UtmSource {
  CampingHr = "camping_hr",
}
